export default {
  hasDropdownLoaded: state => state.commonObj.hasDropdownLoaded,
  commonObj: state => state.commonObj,
  currentFiscalYearId: state => state.currentFiscalYearId
}
